import { render, staticRenderFns } from "./invoicesTable.vue?vue&type=template&id=13cb20b0&scoped=true&"
import script from "./invoicesTable.vue?vue&type=script&lang=js&"
export * from "./invoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./invoicesTable.vue?vue&type=style&index=0&id=13cb20b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb20b0",
  null
  
)

export default component.exports